import React from "react";

import "./ItemDetail.scss";

function getNumberFormat(price) {
  return new Intl.NumberFormat("en-US").format(price);
}
const ItemDetail = ({ data }) => (
  <div className="item-detail">
    {data?.itemSeq? (<>
    <p className="item-name">{data.pluNm}</p>
    <hr />
    <div className="detail-area">
      <div className="img-area">
        {data.imgNm.length ? (
          <img src={require(`../../images/items/${data.imgNm}`)} alt="item-detail-info" />
        ) : (
          <img src={require("../../images/items/item-none.png")} alt="item-detail-info" />
        )}
      </div>
      <div className="txt-area">
        {data.offerCd?.length ? (
          <div className="item-detail-offer">
            <p>{data.offerNm.slice(0, 13)}</p>
            <p className="offer-area">{data.offerNm.slice(13)}</p>
          </div>
        ) : (
          <div className="item-detail-qty-amt">
            <div className="qty-area">
              <p>수량</p>
              <p className="num-area">
                <span>{getNumberFormat(data.saleQty)}</span>
              </p>
            </div>
            <div className="amt-area">
              <p>금액</p>
              <p className="num-area">
                <span>{getNumberFormat(data.totAmt)}</span> 원
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
    </>):<></>}
  </div>
);

export default ItemDetail;
